import * as React from 'react';
/**
 * Sets up an effect that is NOT triggered during a component’s first render.
 */
export function useEffectPostInitialRender(effectFn, deps) {
    var isInitialRender = React.useRef(true);
    React.useEffect(function () {
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        return effectFn();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
useEffectPostInitialRender.displayName = 'useEffectPostInitialRender';
